import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BudgetSummaryModel } from '../../../../core/models/data/budget-summary.model';
import { OrgDatePipe } from '../../../../core/pipes/org-date/org-date.pipe';

@Component({
  selector: 'ms-budget-summary-header',
  imports: [CommonModule, FontAwesomeModule, OrgDatePipe],
  templateUrl: './budget-summary-header.component.html',
})
export class BudgetSummaryHeaderComponent {

  public summary = input<BudgetSummaryModel | undefined>(undefined);
  public isLoading = input<boolean>(false);
}
